import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Loader, Tiles, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';

import ReportOverview from './ReportOverview.js';
import Header from '../../components/Header.js';
import permissionLevel from '../../services/permissions.js';
import reportsData from './reportsData.js';

class Reports extends Component {
    state = {
        selectedSection: null
    };

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Reports', props.accessType).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    _selectSection = (section) => {
        this.setState({
            selectedSection: section
        });
    };

    _buildBreadcrumbs = () => {
        if (!this.state.selectedSection) {
            return null;
        }

        return [
            {
                title: 'Reports',
                link: `/reports`,
                onClick: () => this._selectSection(null)
            }
        ];
    };

    _getSubHeader = () => {
        if (this.state.selectedSection === 'Admin Reports') {
            return 'Admin Reports';
        } else if (this.state.selectedSection === 'Accounting Reports') {
            return 'Accounting Reports';
        } else if (this.state.selectedSection === 'Underwriting Reports') {
            return 'Underwriting Reports';
        } else if (this.state.selectedSection === 'Marketplace Reports') {
            return 'Marketplace Reports';
        } else if (this.state.selectedSection === 'Business Insight Reports') {
            return 'Business Insight Reports';
        }

        return 'Reports';
    };

    render() {

        const subHeader = this._getSubHeader();
        const breadcrumbs = this._buildBreadcrumbs();

        let tiles = [
            {
                title: 'Admin Reports',
                description: 'Reports about groups, members, and claims.',
                onClick: () => this._selectSection('Admin Reports'),
                testid: 'admin-reports-tile'
            },
            {
                title: 'Accounting Reports',
                description: 'Reports for financing and accounting.',
                onClick: () => this._selectSection('Accounting Reports'),
                testid: 'accounting-reports-tile'
            }, 
            {
                title: 'Underwriting Reports',
                description: 'Reports for group renewals and carriers.',
                onClick: () => this._selectSection('Underwriting Reports'),
                testid: 'underwriting-reports-tile'
            },
            {
                title: 'Business Insight Reports',
                description: 'Reports about company metrics and sales.',
                onClick: () => this._selectSection('Business Insight Reports'),
                testid: 'business-reports-tile'
            },
            {
                title: 'Marketplace Reports',
                description: 'Reports for the Simply Benefits Marketplace.',
                onClick: () => this._selectSection('Marketplace Reports'),
                testid: 'marketplace-reports-tile'
            }
        ];

        return (
            <ContainerControlSite>
                <Header
                    subHeader={ subHeader }
                    breadcrumbs={ breadcrumbs }
                    selectedTitle="reports"
                />

                <Content>
                    {
                        this.state.selectedSection === null ?
                            <Tiles tiles={ tiles } />
                            :
                            <ReportOverview
                                reportSectionData={ reportsData[this.state.selectedSection] }
                            />
                    }
                </Content>

                { this.props.loader?.isLoading && <Loader isContainer/> }

                <span id="reports" />
            </ContainerControlSite>
        );
    }
}

Reports.propTypes = {
    accessType: PropTypes.string
};

/**
 * @param state
 * @returns {{loading: *}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    accessType: state.master.access
});

export default (connect(mapStateToProps)(Reports));